import { createRouter, createWebHistory } from 'vue-router'

import HomeRoutes from '@/modules/home/routes'
import AuthRoutes from '@/modules/auth/routes'
import ProfileRoutes from '@/modules/profile/routes'

const routes = [
  ...HomeRoutes,
  ...AuthRoutes,
  ...ProfileRoutes,
  {
    path: '/:pathMatch(.*)*',
    redirect: to => {
      return { name: 'NotFound', query: to.query }
    }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// router.beforeEach(async (to, from, next) => {
//   if (to.fullPath == '/' || to.fullPath == '/2'){
//     next()
    //Redirect to CMS page
    // window.location.href = `${process.env.VUE_APP_SERVER_BASE_URL}`

    //check if it has local storage or not
    // if (!localStorage.getItem('updatedHomePagePreference')) {
    //     //set updatedHomePagePreference as per time
    //     const today = new Date();
    //     const seconds = today.getSeconds(); 
    //     console.log(seconds);
    //     let pagePreference = '';
    //     if (seconds % 2 === 0 ) {
    //       pagePreference = 'a';
    //     } else {
    //       pagePreference = 'b';
    //     }
        
    //     const formatYmd = date => date.toISOString().slice(0, 10);
    //     const user_preference_data = {
    //       user_visited_at: formatYmd(today)+' '+today.getHours()+':'+today.getMinutes()+':'+today.getSeconds(),
    //       homepage_preference: pagePreference
    //     }
    //     let redirect = '/';
    //     await axios.post('/ab-testing-preference', user_preference_data).then (data => {
    //       if (data.data.result) {
    //         localStorage.setItem('updatedHomePagePreference', data.data.pagePreference);
    //         if (data.data.pagePreference == 'a') {
    //           redirect = '/';
    //         } else {
    //           redirect = '/2'
    //         }
    //       } else {
    //         console.log('exception generated from server side');
    //         localStorage.setItem('updatedHomePagePreference', pagePreference);
    //         if (pagePreference == 'a') {
    //           redirect = '/';
    //         } else {
    //           redirect = '/2'
    //         }
    //       }
    //     })
    //     next(redirect);
    // }
    
//   }
//   window.scrollTo(0, 0)
//   next()
// })

export default router
